import { ERROR_MESSAGES, REQUEST } from '../../consts';
import { IAppState, TMembershipPolicy } from '../../types/state.d';
import {
  PageMembership,
  PageType,
  UpdateTeamMutation,
  UpdateTeamMutationVariables,
} from '../../../types/graphql';
import { apiActions, httpActions } from '..';
import client, { hasUnauthenticatedError } from '../../apolloClient';
import { getTeamGuid } from '../../selectors/apiSelectors';

import { Action } from 'redux';
import { Auth } from '@justgiving/auth';
import { ThunkDispatch } from 'redux-thunk';
import UpdateMutation from '../../queries/updateTeamMutation.gql';
import { redirectByResponseStatus } from '../../utils';

const updateMembershipPolicy = (membershipPolicy: TMembershipPolicy) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.UPDATE_MEMBERSHIP_POLICY;
  try {
    await auth.refreshAccessTokenIfExpired();
    const teamGuid = getTeamGuid(getState());

    dispatch(httpActions.httpRequestMade(resourceName));

    if (!teamGuid) {
      throw new Error('Team guid not found');
    }

    const mapToPageMembership = (membershipPolicy: TMembershipPolicy) => {
      switch (membershipPolicy) {
        case 'open':
          return PageMembership.Open;
        case 'invite-only':
          return PageMembership.InviteOnly;
        default:
          return undefined;
      }
    };

    const { errors } = await client.mutate<
      UpdateTeamMutation,
      UpdateTeamMutationVariables
    >({
      mutation: UpdateMutation,
      variables: {
        input: {
          id: teamGuid,
          type: PageType.Team,
          membershipType: mapToPageMembership(membershipPolicy),
        },
      },
    });

    if (errors && hasUnauthenticatedError(errors)) {
      redirectByResponseStatus(401);
    }

    if (errors) {
      throw new Error(ERROR_MESSAGES.UPDATE_MEMBERSHIP_POLICY);
    }

    dispatch(apiActions.saveMembershipPolicy(membershipPolicy));
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error as Error));
  }
};

export default updateMembershipPolicy;
